
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useClaimRobots } from '../utils/robotsOwnership';
import { publicFeatures } from '../config/publicFeatures';
import { Home, Search, ArrowLeft } from 'lucide-react';

export function NotFoundPage() {
  useClaimRobots();
  return (
    <>
    <Helmet>
      <title>Page not found | TechieDay</title>
      <meta name="robots" content="noindex, follow" />
      <meta name="googlebot" content="noindex, follow" />
    </Helmet>
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md mx-auto text-center px-4">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-gray-300">404</h1>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Page Not Found</h2>
          <p className="text-gray-600 mb-8">
            Sorry, the page you're looking for doesn't exist or may have been moved.
          </p>
        </div>
        
        <div className="space-y-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Home size={20} />
            Go to Homepage
          </Link>
          
          <div className="flex gap-2 justify-center">
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <ArrowLeft size={16} />
              Go Back
            </button>
            
            {publicFeatures.dailyDeals && (
            <Link
              to="/daily-deals"
              className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <Search size={16} />
              Browse Deals
            </Link>
            )}
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
